import PreApprovedMedicalAmount from "./PreApprovedMedicalAmount";

export default PreApprovedMedicalAmount;
